<template>
  <div class="animated fadeIn">
    <!-- 시스템의 기본 서비스 관리 추가 -->
    <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Base Service
      </template>
      <b-row>
        <b-col md="9">
          <h4>
            <b-badge variant="danger">* Notice</b-badge>
          </h4>
          - Newly created services are available to partners after the system is created.
        </b-col>
        <b-col md="3">
          <b-button v-if="view_detail != false" size="sm" variant="success" class="pull-right mx-1" @click="service_new = true; confirm_info = true; service = {}"> New Registration </b-button>
          <b-button size="sm" variant="info" class="pull-right mx-1" @click="$refs._list.refresh()"> Refresh </b-button>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load_service" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <c-switch @change="status_change($event, row.item, 'is_alive')" color="warning" label v-model="row.item.status" />
        </template>
        <template slot="name" slot-scope="row">
          <b-btn @click="status_change(row.item, row.item, 'is_del')" variant="outline-danger" size="sm">Delete</b-btn>
          {{row.item.name}}
        </template>
        <template slot="list_price" slot-scope="row">{{row.item.list_price | dollar}}</template>
        <template slot="min_price" slot-scope="row">{{row.item.min_price | dollar}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table>
    </b-card>

    <!-- 기존 파트너의 가격 수정 여부 확인 모달 -->
    <b-modal hide-footer title="System service price was changed"  class="modal-warning" v-model="confirm_all">
      you want to apply a new price to my existing partner?
      if press "only update the price.", Accounts created after application will be affected by the price updated
      <b-button class="mt-3" variant="outline-warning" block @click="confirm_all = false; upsert_service()">only update the price.</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="service.apply_all = true; upsert_service()">Apply the price</b-button>
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal title="System update info"  class="modal-danger" v-model="confirm_save" @ok="confirm_refresh = true" ok-variant="danger">
      Are you sure you want to update this info?
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal :title="`System service ${service.is_alive ? 'Enable' : 'Disable'}`"  class="modal-warning" v-model="confirm_toggle" hide-footer ok-variant="warning">
      Are you sure you want to {{service.is_alive ? "Enable" : "Disable"}} this service?
      <hr>
      <b-button variant="warning" block @click="toggle_service">OK</b-button>
      <b-button variant="primary" block @click="cancel">Cancel</b-button>
    </b-modal>
    <!-- 삭제 확인 모달 -->
    <b-modal title="System service Delete"  class="modal-danger" v-model="confirm_delete" @ok="delete_service" ok-variant="danger">
      Are you sure you want to delete this service?
    </b-modal>
    <!-- 해당 시스템의 서비스 모달 시작 -->
    <b-modal hide-footer title="System serevice info"  header-bg-variant="info" v-model="confirm_info" @ok="confirm_info = false" ok-only ok-variant="info">
      <b-row>
        <b-col sm="4"> <label for="service_name">Name :</label> </b-col>
        <b-col sm="8">
          <b-input-group prepend="#">
            <b-input class="m-1" id="service_name" placeholder="typing service name" v-model="service.name" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
        <b-col sm="4"> <label class="text-danger font-weight-bold" for="service_cost_price">Cost Price :</label> </b-col>
        <b-col sm="8">
          <b-input-group prepend="$">
            <b-input class="m-1" type='number' id="service_cost_price" placeholder="typing cost price" v-model="service.min_price" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
        <b-col sm="4"> <label class="text-warning font-weight-bold" for="public_price">Public Price :</label> </b-col>
        <b-col sm="8">
          <b-input-group prepend="$">
            <b-input class="m-1" type='number' id="public_price" placeholder="typing public price" v-model="service.list_price" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="4"> <label class="text-info font-weight-bold" for="public_price">Target Domain :</label> </b-col>
        <b-col sm="8">
          <b-input class="m-1" type='number' id="public_price" placeholder="typing target domain" v-model="service.target_domain" :dsiable="lock"></b-input>
        </b-col>
        <b-col><span>* Example, if sales target domain is 5 +, -5 else 1 ~ 4 is 4 </span></b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_wmds_site">WMDS :</label> </b-col>
        <b-col sm="3">
          <c-switch id="service_wmds_site" color="info" label v-model="service.use_wmds" />
        </b-col>
        <b-col sm="3"> <label for="service_wmds_analysis">Analysis :</label> </b-col>
        <b-col sm="2">
          <c-switch id="service_wmds_analysis" color="info" label v-model="service.use_wmds_analysis" />
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="3"> <label for="service_wmds_page">Max Page :</label> </b-col>
        <b-col sm="3">
          <b-input id="service_wmds_page" placeholder="Number" v-model="service.wmds_page" :dsiable="lock"></b-input>
        </b-col>
        <b-col sm="3"> <label for="service_wmds_total">Page(Month) :</label> </b-col>
        <b-col sm="3">
          <b-input id="service_wmds_total" placeholder="Number" v-model="service.wmds_total" :dsiable="lock"></b-input>
        </b-col>
      </b-row>
      <br>
      <b-col sm="12">
         * Max Page : count of max pages use to site scanning
         <br>
         * Page(Month) : typing wmds total during month
      </b-col>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_waf">WAF :</label> </b-col>
        <b-col sm="2">
          <c-switch id="service_waf" color="info" label v-model="service.use_waf" />
        </b-col>
        <b-col sm="3"> <label for="service_waf_doamin">Domain :</label> </b-col>
        <b-col sm="4">
          <b-input id="service_waf_doamin" placeholder="Limit" v-model="service.waf_domain" :dsiable="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_wmds_wsfinder">WSFinder :</label> </b-col>
        <b-col sm="2">
          <c-switch id="service_wmds_wsfinder" color="info" label v-model="service.use_wsfinder" />
        </b-col>
        <b-col sm="3"> <label for="service_wsfinder_analysis">Analysis :</label> </b-col>
        <b-col sm="2">
          <c-switch id="service_wsfinder_analysis" color="info" label v-model="service.use_wsfinder_analysis" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_wmds_integrity">Integrity :</label> </b-col>
        <b-col sm="3">
          <c-switch id="service_wmds_integrity" color="info" label v-model="service.use_integrity" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_is_alive">Status :</label> </b-col>
        <b-col sm="9">
          <c-switch id="service_is_alive" color="info" label v-model="service.is_alive" />
        </b-col>
      </b-row>
      <hr>
      <center><h4>Support</h4></center>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="dedicated_support">Dedicated :</label> </b-col>
        <b-col sm="3">
          <c-switch id="dedicated_support" color="info" label v-model="service.use_technical_support" />
        </b-col>
        <b-col sm="3"> <label for="install_support">Install :</label> </b-col>
        <b-col sm="3">
          <c-switch id="install_support" color="info" label v-model="service.use_install_support" />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3"> <label for="policy_support">Policy :</label> </b-col>
        <b-col sm="3">
          <c-switch id="policy_support" color="info" label v-model="service.use_policy_support" />
        </b-col>
        <b-col sm="3"> <label for="phone_support">Phone :</label> </b-col>
        <b-col sm="3">
          <c-switch id="phone_support" color="info" label v-model="service.use_phone_support" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="email_support">Email :</label> </b-col>
        <b-col sm="9">
          <b-form-input type='number' id="email_support" placeholder="typing within hour response email support" v-model="service.email_support" :dsiable="lock"></b-form-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="3"> <label for="service_description">Description :</label> </b-col>
        <b-col sm="9">
          <b-form-textarea id="service_description" placeholder="typing description" v-model="service.description" :dsiable="lock"></b-form-textarea>
        </b-col>
      </b-row>
      <hr>
      <b-button class="mt-3" variant="outline-info" block @click="confirm_all = true">
        {{service_new ? 'save' : 'update'}}
      </b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="confirm_info = false">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import config from '@/config';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

export default {

  components: { DatePicker, cSwitch, vSelect, PictureInput },
  name : "ServiceList",
  props : ["auto_refresh", "enable_new", "view_detail"],
  data: () => ({
    config,
    loading : false,
    lock : true,
    confirm_refresh : false,
    confirm_all : false,
    confirm_info: false,
    confirm_toggle : false,
    confirm_delete : false,
    confirm_save : false,
    type : '',
    toggle : 'password',
    custom,
    codes,
    service_new : false,
    service : {},
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0,
      license : { data : {}, data_json : { key : {}, info : {} }, list : [] },
      logo : { data : { slogan : '', image : ''} },
      mail : { data : {} },
      rule : { data : {} }
    },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    url() { return `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}` },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = []
      f.push({ key: 'id', thStyle: 'width: 10%', label: 'No.' })
      f.push({ key: 'is_alive', sortable: true, label: 'Status'});
      f.push({ key: 'name', sortable: true, label: 'Name'});
      f.push({ key: 'list_price', sortable: true, label: 'Public price' });
      f.push({ key: 'min_price', label: 'Cost price', sortable: true });
      f.push({ key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  });
      return f;
    },
  },
  methods: {
    cancel() {
      if(this.$refs._list) { this.$refs._list.refresh() }
      this.confirm_toggle = false
    },
    detail(item) {

      try {
        if(this.view_detail != false) {
          this.lock = true
          this.service = item
          this.service.use_wmds = this.service.wmds_site > 0 ?  true  : false
          this.service.use_waf = this.service.waf > 0 ?  true  : false
          this.service.use_wsfinder = this.service.wsfinder > 0 ?  true  : false
          this.service.use_integrity = this.service.integrity > 0 ?  true  : false

          // add

          this.service.target_domain = this.service.target_domain
          this.service.email_support = this.service.email_support

          this.service.use_wsfinder_analysis = this.service.wsfinder_analysis == 1
          this.service.use_wmds_analysis = this.service.wmds_analysis == 1

          this.service.use_technical_support = this.service.technical_support == 1
          this.service.use_install_support = this.service.install_support == 1
          this.service.use_policy_support = this.service.policy_support == 1
          this.service.use_phone_support = this.service.phone_support == 1


          console.log(item)

          this.confirm_info = true
        } else {
          this.$emit('get_basic_service', item.id)
        }
      } catch (e) { console.log(e) }
    },
    async load_service(ctx = {}) {
      try {
        let so = { target : 'service', cmd : 'list', body : { and : [{ name : 'is_del', value : false, op : '=' }] } }
        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        let rs = await Api.Manager(so);
        if(rs.error) { this.$toastr.e("failed", rs.reason); return [] }
        this.so.totalRows = rs.total;
        if(rs.body) {
          rs.body.forEach(r => {
            r.status = r.is_alive;
          });
          return rs.body
        }
        return []
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async upsert_service() {
      try {
        if(!this.service.min_price || this.service.min_price < 0 || typeof this.service.min_price == 'undefined') {
          return this.$toastr.e("Cost price", "not a number")
        } else { this.service.min_price = typeof this.service.min_price != 'number' ? this.service.min_price : this.service.min_price.toFixed(2) }
        if(!this.service.list_price || this.service.list_price < 0 || typeof this.service.list_price == 'undefined') {
          return this.$toastr.e("Public price", "not a number")
        } else { this.service.list_price = typeof this.service.list_price != 'number' ? this.service.list_price : this.service.list_price.toFixed(2) }

        // convert
        this.service.wmds_site = this.service.use_wmds == true ? 1 : 0
        this.service.wsfinder = this.service.use_wsfinder == true ? 1 : 0
        this.service.waf = this.service.use_waf == true ? 1 : 0
        this.service.integrity = this.service.use_integrity == true ? 1 : 0

        // add
        this.service.wsfinder_analysis = this.service.use_wsfinder_analysis == true ? 1 : 0 // boolean
        this.service.wmds_analysis = this.service.use_wmds_analysis == true ? 1 : 0 // boolean

        this.service.target_domain = this.service.target_domain // number
        this.service.technical_support = this.service.use_technical_support == true ? 1 : 0 // boolean
        this.service.install_support = this.service.use_install_support == true ? 1 : 0 // boolean
        this.service.policy_support = this.service.use_policy_support == true ? 1 : 0 // boolean
        this.service.phone_support = this.service.use_phone_support == true ? 1 : 0 // boolean
        this.service.email_support = this.service.email_support // number


        let rs = await Api.Manager({ target : 'service', cmd : this.service_new ? 'insert' : 'update', body : this.service });
        if(rs.error) { this.$toastr.e(this.service_new ? 'create' : 'update' + " failed", rs.reason); }
        else { this.$toastr.s("saved", this.$route.name); }
        this.service_new = false;
        this.confirm_info = false;
        this.confirm_all = false;
        this.$refs._list.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async toggle_service() {
      try {

        if(!this.service.name) { return this.$toastr.e("select first") }
        this.confirm_toggle = false;

        let rs = await Api.Manager({ target : 'service', cmd : 'update', body : Object.assign({}, this.service ) });
        if(rs.error) { this.$toastr.e("failed", rs.reason); }
        else { this.$toastr.s("saved", this.$route.name); }
        this.$refs._list.refresh()
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async delete_service() {
      try {
        if(!this.service.name) { return this.$toastr.e("select first") }
        let rs = await Api.Manager({ target : 'service', cmd : 'delete', body : this.service });
        if(rs.error) { this.$toastr.e("failed", rs.reason); }
        else { this.$toastr.s("saved", this.$route.name); }
        this.$refs._list.refresh()
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    status_change($event, item, type) {
      if($event == item.is_alive) { console.log("is loading"); return; }
      this.service = item
      this.service.is_alive = $event;

      if(type == 'is_del') {
        this.confirm_delete = true
      } else {
        this.confirm_toggle = true;
      }

    },
    list() { this.$emit('refresh'); },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() { console.log('group.list.vue', 'mounted'); },
}
</script>
